// extracted by mini-css-extract-plugin
module.exports = {"popup":"details_popup__1uypg","item":"details_item__AP6nN"};